import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Nav, Navbar } from 'react-bootstrap';

// eslint-disable-next-line no-unused-vars
import SearchComponent from './SearchComponent';

import './NavBar.css';

export default function NavBar() {
    const [expanded, setExpanded] = useState(false);
    const handleNavClick = () => {
        setExpanded(false);
    };

    return (
        <section id="navbar">
            <div className="blue-bar" />
            <Navbar
                expanded={expanded}
                onToggle={() => setExpanded(!expanded)}
                className="bg-body-tertiary"
                expand="xl"
                bg="light"
                sticky="top"
            >
                <Container>
                    <Navbar.Brand as={Link} to="/">
                        <h1 className="text-primary">Roadrunner Connect</h1>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="right-aligned" className="">
                        <Nav className="mr-auto">
                            <Nav.Link
                                as={Link}
                                to="/about"
                                onClick={handleNavClick}
                            >
                                <div className="nav-btn h3">About</div>
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to="/policies"
                                onClick={handleNavClick}
                            >
                                <div className="nav-btn h3">Policies</div>
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to="/project-updates"
                                onClick={handleNavClick}
                            >
                                <div className="nav-btn h3">
                                    Project Updates
                                </div>
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to="/contact"
                                onClick={handleNavClick}
                            >
                                <div className="nav-btn h3">Contact</div>
                            </Nav.Link>
                        </Nav>
                        {/* The below logic can be uncommented to integrate the search component back
             into the NavBar when needed */}
                        {/* <SearchComponent
               showSearchForm = {showSearchForm}
               setShowSearchForm = {setShowSearchForm}
               showSearchIcon = {showSearchIcon}
               setShowSearchIcon = {setShowSearchIcon}
               />    */}
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </section>
    );
}
